import { ISettingsStore } from './settings-store';
import { Observable, of } from 'rxjs';

export class DefaultValuesSettingsStore implements ISettingsStore {
  constructor(private _defaults: { [key: string]: string }) {}
  getSetting$(key: string): Observable<string | null> {
    if (!this._defaults || this._defaults === null) {
      return of(null);
    }
    return of(this._defaults[key]);
  }
  setSetting$(settingKey: string, value: string): Observable<boolean> {
    return of(true);
  }
}
